let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eoJez")).then(() => parcelRequire('dlrOi'));